/** On-demand navigation for moving between articles in the current series. */

export function initSeriesSwitcher(): void {
  const switcher = document.querySelector<HTMLElement>('[data-series-switcher]')
  if (!switcher) return

  const trigger = switcher.querySelector<HTMLButtonElement>('[data-series-trigger]')
  const panel = switcher.querySelector<HTMLElement>('[data-series-panel]')
  const close = switcher.querySelector<HTMLButtonElement>('[data-series-close]')
  const scrim = switcher.querySelector<HTMLElement>('[data-series-scrim]')
  if (!trigger || !panel || !close || !scrim) return

  let lastFocus: HTMLElement | null = null

  const setOpen = (open: boolean): void => {
    switcher.classList.toggle('is-open', open)
    trigger.setAttribute('aria-expanded', String(open))
    panel.setAttribute('aria-hidden', String(!open))
    document.body.classList.toggle('series-switcher-open', open)

    if (open) {
      lastFocus = document.activeElement as HTMLElement
      close.focus()
    } else {
      lastFocus?.focus()
    }
  }

  trigger.addEventListener('click', () => setOpen(!switcher.classList.contains('is-open')))
  close.addEventListener('click', () => setOpen(false))
  scrim.addEventListener('click', () => setOpen(false))

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && switcher.classList.contains('is-open')) {
      setOpen(false)
    }
  })
}
